export default "__VITE_ASSET__DCiQBqj2__"